export var LOAD_POLICIES = {
  CACHE_FIRST: 'cache-first',
  CACHE_AND_LOAD: 'cache-and-load',
  LOAD_ONLY: 'load-only'
};
export var CACHEABLE_LOAD_POLICIES = [LOAD_POLICIES.CACHE_FIRST, LOAD_POLICIES.CACHE_AND_LOAD];

export var getCachedResponseFromProps = function getCachedResponseFromProps(props) {
  var contextKey = props.contextKey,
      getCachedResponse = props.getCachedResponse,
      loadPolicy = props.loadPolicy;

  if (getCachedResponse) {
    var cache = getCachedResponse({ contextKey: contextKey });
    if (cache && CACHEABLE_LOAD_POLICIES.includes(loadPolicy)) {
      var error = cache.error,
          response = cache.response,
          state = cache.state;

      return {
        hasResponseInCache: true,
        cachedState: state,
        error: error,
        response: response
      };
    }
  }
  return {
    hasResponseInCache: false
  };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-loads/es/utils.js
// module id = 1612
// module chunks = 0